import { useState, useRef } from 'react';
import { FieldDictionary } from '@shopify/react-form';
import useAuth from '@sdk/authentication/useAuth';
import validateTime from '@sdk/utils/validation/validateTime';

import { TimeClockEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import {
  findTheClosestNextSlot,
  getDefaultClockInPickerStartSlot,
  getDefaultClockOutPickerStartSlot,
} from '@web/timesheets/CreateTimesheetModal/components/rows/TimeClockRow/timeClockRow.utils';
import { StartDateWithLocalTime } from '@web/timesheets/EditTimesheetModal/editTimesheetModal.types';

type Props = {
  timeClockFieldSet: FieldDictionary<TimeClockEntry>;
  intervalInMinutes: number;
  scheduledShiftStart?: StartDateWithLocalTime;
};
export const useTimeClockRow = ({
  timeClockFieldSet,
  intervalInMinutes,
  scheduledShiftStart,
}: Props) => {
  const { currentUser } = useAuth();
  const { usTimeFormat } = currentUser.settings;

  const clockInStartHour = useRef(
    timeClockFieldSet.clockIn.value ||
      getDefaultClockInPickerStartSlot(intervalInMinutes, scheduledShiftStart?.dtstartLocal)
  ).current;
  const [clockOutStartHour, setClockOutStartHour] = useState(
    () =>
      timeClockFieldSet.clockOut.value ||
      getDefaultClockOutPickerStartSlot(intervalInMinutes, scheduledShiftStart?.dtstartLocal)
  );

  const onClockInChange = (value: string) => {
    timeClockFieldSet.clockIn.onChange(value);
    if (validateTime(value)) {
      const closestEndSlot = findTheClosestNextSlot(value, intervalInMinutes);
      setClockOutStartHour(closestEndSlot);
    }
  };

  return {
    onClockInChange,
    usTimeFormat,
    clockInStartHour,
    clockOutStartHour,
  };
};
